<template>
    <div>
        <Form :model="detailForm" :label-width="80" ref="detailForm">
            <FormItem prop="name" label="名称">
                <Input type="text" :value="detailForm.name" style="width:300px;" readonly/>
            </FormItem>
            <FormItem prop="zone_id" label="校区">
                <Input type="text" :value="detailForm.zoneName" style="width:300px;" readonly/>
            </FormItem>
            <FormItem prop="zone_id" label="课程">
                <Input type="text" :value="detailForm.courseName" style="width:300px;" readonly/>
            </FormItem>
            <FormItem prop="stu_no" label="状态">
                <Input type="text" :value="detailForm.state|stateFilter" style="width:300px;" readonly/>
            </FormItem>
            <FormItem prop="stu_no" label="每次扣课时">
                <Input type="text" :value="detailForm.hour_num" style="width:300px;" readonly/>
            </FormItem>
        </Form>
    </div>
</template>

<script>
  export default {
    name: 'clazz_basic',
    props: {
      detailForm: Object,
      clazzId: Number
    },
    data() {
      return {
      }
    },
    methods: {
    },
    filters:{
      stateFilter:(state)=>{
        if (state == 1){
          return '正常'
        }else if (state == 3){
          return '已结课'
        }
        return '-';
      }
    },
  }
</script>
